//Custom style and options for toast its imported in index.tsx

export const ToastOptions = {};

export const ContainerStyle = {
  top: 20,
};
